import { useEffect, useState } from 'react';

import { Divider } from '@mui/material';

import BundleOICLicenseFourthPlusRenewalForm from './BundleOICLicenseFourthPlusRenewalForm';
import BundleOICLicenseRenewalForm from './BundleOICLicenseRenewalForm';

import LicenseTitle from '@components/atoms/LicenseTitle';
import OICLicenseFourthPlusRenewalForm from '@components/molecules/cpdEnrollment/licenseInformation/OICLicenseFourthPlusRenewalForm';
import OICLicenseRenewalForm from '@components/molecules/cpdEnrollment/licenseInformation/OICLicenseRenewalForm';
import TSI from '@components/molecules/cpdEnrollment/licenseInformation/tsi';
import { dateFormatThai } from 'src/helpers/utils';
import {
  CPDRegulatorTypeEnum,
  LicenseRenewalTypeEnum,
  ICPDLicense,
  CPDLicenseTypeEnum,
  ApplicantTypeEnum,
  ICPDCourse,
} from 'src/interfaces';
import { IProductDetail } from 'src/interfaces/product';

type Props = {
  customerLicenses: ICPDLicense[];
  cpdCourses: ICPDCourse[];
  isBundle?: boolean;
};

const LicenseInformation = ({ customerLicenses, cpdCourses, isBundle = false }: Props) => {
  const [oic1to3Courses, setOic1to3Courses] = useState<ICPDCourse[]>([]);
  const [oicFourthPlusCourses, setOicFourthPlusCourses] = useState<ICPDCourse[]>([]);
  const [tsiCourses, setTsiCourses] = useState<ICPDCourse[]>([]);

  const [applicantType, setApplicantType] = useState<ApplicantTypeEnum | string>(cpdCourses[0].applicantType);
  const [licenseType, setLicenseType] = useState<CPDLicenseTypeEnum | string>(cpdCourses[0].licenseTypes[0]);

  useEffect(() => {
    const oic1to3CoursesData = cpdCourses.filter(
      (course) =>
        course.regulator === CPDRegulatorTypeEnum.OIC &&
        course.licenseRenewal !== LicenseRenewalTypeEnum.RequestLicense &&
        course.licenseRenewal !== LicenseRenewalTypeEnum.FourthPlusRenewal,
    );

    const oicFourthPlusCoursesData = cpdCourses.filter(
      (course) =>
        course.regulator === CPDRegulatorTypeEnum.OIC &&
        course.licenseRenewal === LicenseRenewalTypeEnum.FourthPlusRenewal,
    );

    const tsiCoursesData = cpdCourses.filter((course) => course.regulator === CPDRegulatorTypeEnum.TSI);

    setOic1to3Courses(oic1to3CoursesData);
    setOicFourthPlusCourses(oicFourthPlusCoursesData);
    setTsiCourses(tsiCoursesData);
  }, [cpdCourses]);

  const isNotOicFourthPlus = !(oicFourthPlusCourses.length !== 0);
  const isNotOic1to3Bundle = !(oic1to3Courses.length > 1);

  return (
    <>
      <LicenseTitle
        regulator={cpdCourses[0].regulator}
        licenseRenewal={cpdCourses[0].licenseRenewal}
        applicantType={applicantType as ApplicantTypeEnum}
        licenseType={licenseType as CPDLicenseTypeEnum}
        cpdCourses={cpdCourses}
        isBundle={isBundle}
      />

      {isNotOicFourthPlus && isNotOic1to3Bundle && <Divider sx={{ my: { xs: '24px', md: '30px' } }} />}
      {tsiCourses.length !== 0 && (
        <TSI
          license={{
            licenseNumber: customerLicenses[0]?.licenseNo,
            applicantType: customerLicenses[0]?.applicantType,
            startDate: '',
            endDate: '',
          }}
        />
      )}
      {oic1to3Courses.length !== 0 && !isBundle && (
        <OICLicenseRenewalForm courseLicenseType={cpdCourses[0].licenseTypes[0]} customerLicenses={customerLicenses} />
      )}

      {oic1to3Courses.length !== 0 && isBundle && (
        <BundleOICLicenseRenewalForm cpdCourses={oic1to3Courses} customerLicenses={customerLicenses} />
      )}

      {oicFourthPlusCourses.length !== 0 && !isBundle && (
        <OICLicenseFourthPlusRenewalForm
          customerLicenses={customerLicenses}
          applicantType={applicantType as ApplicantTypeEnum}
        />
      )}

      {oicFourthPlusCourses.length !== 0 && isBundle && (
        <BundleOICLicenseFourthPlusRenewalForm customerLicenses={customerLicenses} />
      )}
    </>
  );
};

export default LicenseInformation;
